import * as authActions from './auth'
import * as queryActions from './query'
import * as storageActions from './storage'

export { authActions, queryActions, storageActions }
export default { authActions, queryActions, storageActions }
